import { BasicReflectionEvent } from './basicReflectionEvent';
export class HighReflectionEvent extends BasicReflectionEvent {
    constructor(previousSite, targetSide, site) {
        super(previousSite.ReflectingObstacle, targetSide.Obstacle, site);
        this.Side = targetSide;
    }
}
//# sourceMappingURL=HighReflectionEvent.js.map